import React, { useEffect } from 'react'
import { observer, inject } from 'mobx-react'
import { withTranslation } from 'react-i18next'

import { selectionTypes } from '../../constants'

import AddItemIcon from '../common/icons/AddItemIcon'
import AddTargetGroupIcon from '../common/icons/AddTargetGroupIcon'
import CloseIcon from '../common/icons/CloseIcon'

const ChooseAddTypeModal = ({ uiStore, selectionStore, dataStore, t }) => {
  useEffect(() => {
    if (uiStore && typeof uiStore.clearHoveredTargetGroup === 'function') {
      uiStore.clearHoveredTargetGroup()
    }
  }, [uiStore])

  const onCloseClick = () => {
    const map = uiStore && uiStore.map && uiStore.map.leafletElement
    const center = map && typeof map.getCenter === 'function' ? map.getCenter() : null
    const zoom = map && typeof map.getZoom === 'function' ? map.getZoom() : null
    const currentBounds = map && typeof map.getBounds === 'function' ? map.getBounds() : null
    if (uiStore && typeof uiStore.suppressMapBoundsTemporarily === 'function') {
      uiStore.suppressMapBoundsTemporarily(1000)
    }
    if (uiStore && currentBounds && typeof uiStore.setBoundsHelper === 'function') {
      uiStore.setBoundsHelper(currentBounds)
    }
    uiStore.hideChooseAddType()
    if (typeof uiStore.restorePreviousSelectionBeforeAdd === 'function') {
      uiStore.restorePreviousSelectionBeforeAdd()
    }
    if (map && center && zoom != null) {
      map.setView(center, zoom, { animate: false })
      setTimeout(() => map.setView(center, zoom, { animate: false }), 0)
    }
  }

  const handleAddItem = (e) => {
    e.currentTarget.blur()
    e.stopPropagation()
    const map = uiStore && uiStore.map && uiStore.map.leafletElement
    const center = map && typeof map.getCenter === 'function' ? map.getCenter() : null
    const zoom = map && typeof map.getZoom === 'function' ? map.getZoom() : null
    const currentBounds = map && typeof map.getBounds === 'function' ? map.getBounds() : null
    if (uiStore && typeof uiStore.suppressMapBoundsTemporarily === 'function') {
      uiStore.suppressMapBoundsTemporarily(1000)
    }
    if (uiStore && currentBounds && typeof uiStore.setBoundsHelper === 'function') {
      uiStore.setBoundsHelper(currentBounds)
    }

    // Determine which group to add the item to
    // 1. Check selectionStore.selectedTargetGroup (set when folder or shape is clicked)
    // 2. Fallback to selectionStore.item if it's a TargetGroup
    // 3. Fallback to the first target group available in dataStore
    let targetGroup = selectionStore.selectedTargetGroup ? selectionStore.selectedTargetGroup.item : null

    if (!targetGroup && selectionStore.item && selectionStore.type === selectionTypes.TARGET_GROUP) {
      targetGroup = selectionStore.item
    }

    if (!targetGroup && dataStore.myTargetGroups.length > 0) {
      targetGroup = dataStore.myTargetGroups[0]
    }

    if (!targetGroup) {
      console.warn('No valid Target Group found to add item to.')
      return
    }

    targetGroup.expanded = true
    selectionStore.select(null, {
      type: selectionTypes.NEW_ITEM,
      data: { group: targetGroup }
    })

    if (typeof uiStore.closeQuickCreate === 'function') {
      uiStore.closeQuickCreate()
    }
    if (typeof uiStore.closeQuickCreateModal === 'function') {
      uiStore.closeQuickCreateModal()
    }
    if (uiStore.map && uiStore.map.leafletElement && typeof uiStore.map.leafletElement.closePopup === 'function') {
      uiStore.map.leafletElement.closePopup()
    }
    if (typeof uiStore.closePoiTooltip === 'function') {
      uiStore.closePoiTooltip()
    }

    selectionStore.toggleSubTools()
    if (map && center && zoom != null) {
      map.setView(center, zoom, { animate: false })
      setTimeout(() => map.setView(center, zoom, { animate: false }), 0)
    }
    uiStore.hideChooseAddType()
  }

  const handleTargetChoiceClick = () => {
    const map = uiStore && uiStore.map && uiStore.map.leafletElement
    const center = map && typeof map.getCenter === 'function' ? map.getCenter() : null
    const zoom = map && typeof map.getZoom === 'function' ? map.getZoom() : null
    const currentBounds = map && typeof map.getBounds === 'function' ? map.getBounds() : null
    if (uiStore && typeof uiStore.suppressMapBoundsTemporarily === 'function') {
      uiStore.suppressMapBoundsTemporarily(1000)
    }
    if (uiStore && currentBounds && typeof uiStore.setBoundsHelper === 'function') {
      uiStore.setBoundsHelper(currentBounds)
    }
    if (typeof uiStore.closeQuickCreate === 'function') {
      uiStore.closeQuickCreate()
    }
    if (typeof uiStore.closeQuickCreateModal === 'function') {
      uiStore.closeQuickCreateModal()
    }
    if (uiStore.map && uiStore.map.leafletElement && typeof uiStore.map.leafletElement.closePopup === 'function') {
      uiStore.map.leafletElement.closePopup()
    }
    if (typeof uiStore.closePoiTooltip === 'function') {
      uiStore.closePoiTooltip()
    }
    uiStore.showAddTargetGroupPane()
    selectionStore.toggleSubTools()
    if (map && center && zoom != null) {
      map.setView(center, zoom, { animate: false })
      setTimeout(() => map.setView(center, zoom, { animate: false }), 0)
    }
    uiStore.hideChooseAddType()
  }

  return (
    <div className='choose-add-type'>
      <button type='button' className='choose-add-type__btn' onClick={handleAddItem}>
        <AddItemIcon />
        {t('CREATE_MODAL.ITEM')}
      </button>
      <button disabled={uiStore.hasExceededTargetGroupLimit} type='button' className='choose-add-type__btn' onClick={handleTargetChoiceClick}>
        <AddTargetGroupIcon />
        {t('CREATE_MODAL.GROUP')}
      </button>
      {uiStore.hasExceededTargetGroupLimit && <span className='choose-add-type__limit'>{t('LIMIT_ERROR_MESSAGE.GROUP_LIMIT')}</span>}
      <button onClick={onCloseClick} type='button' className='choose-add-type__close-btn'>
        <CloseIcon />
      </button>
    </div>
  )
}

export default withTranslation()(inject('uiStore', 'selectionStore', 'dataStore')(observer(ChooseAddTypeModal)))
